/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ecg': {
    width: 20,
    height: 16,
    viewBox: '0 0 20 16',
    data: '<defs/><path pid="0" id="ecg" class="cls-1" d="M35.056 89l-4.213-11.193-1.932 5.264H25v-1.7h2.756l3.068-8.356 4.12 10.943 2.4-7.36 2.336 4.772H45v1.7h-6.349l-1-2.037z" transform="translate(-25 -73)"/>'
  }
})
